var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0C7.6112 0 3.72467e-05 7.61116 3.72467e-05 17V33.1551H0V44.0195H3.72467e-05V64V111C3.72467e-05 120.389 7.6112 128 17 128H64.2498H111.5C120.888 128 128.5 120.389 128.5 111V64V17C128.5 7.61116 120.888 0 111.5 0H64.2498H17ZM3.72467e-05 44.0195H27.5528C29.5255 48.8193 34.2471 52.199 39.758 52.199C41.5519 52.199 43.2622 51.8409 44.8212 51.1923L78.3283 84.6994C77.6855 86.2525 77.3307 87.9551 77.3307 89.7405C77.3307 97.0253 83.2362 102.931 90.521 102.931C97.8058 102.931 103.711 97.0253 103.711 89.7405C103.711 82.4557 97.8058 76.5502 90.521 76.5502C89.0264 76.5502 87.5898 76.7988 86.2504 77.2569L53.013 44.0195H78.3782C80.3509 48.8193 85.0725 52.199 90.5834 52.199C97.8682 52.199 103.774 46.2936 103.774 39.0088C103.774 31.724 97.8682 25.8185 90.5834 25.8185C85.401 25.8185 80.9167 28.8073 78.76 33.1551H51.5815C49.4248 28.8073 44.9404 25.8185 39.758 25.8185C34.5756 25.8185 30.0913 28.8073 27.9346 33.1551H3.72467e-05V44.0195Z",
    fill: "#F0E3CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.e96c0e73a32510078fbca0a7bd34283c.svg";
export { ForwardRef as ReactComponent };